import SEOHelmet from "@/components/helpers/seo/SEOHelmet";
import PublicFooter from "@/components/nav/PublicFooter";
import PublicNav from "@/components/nav/PublicNav";
import { Col, Container, Row } from "@/components/pieces/bootstrap";
import { DOMAIN, SITE_NAME } from "@/css/constants";

export default function Tos() {
  return (
    <>
      <SEOHelmet
        title={`Terms of Service at ${SITE_NAME}`}
        description={`Learn more about ${SITE_NAME}’s Terms of Service, which governs your use of ${SITE_NAME} and the products, features, apps, services, technologies, and software we offer.`}
        canonicalPath={`https://www.${DOMAIN}/tos`}
        bodyAttributes={{ class: "public-site" }}
      />
      <PublicNav />
      <div className="public-content">
        <Container my="4rem">
          <Row>
            <Col width={[1, 1, 5 / 6]} ml={[0, 0, "8.33333333%"]}>
              <h1>{SITE_NAME} Terms of Service</h1>
              <p>Last changed: April 1, 2024</p>

              <p>
                These Terms of Services apply to your use of {DOMAIN}, and any
                other websites, applications, or services provided, owned or
                operated by Exec Holdings, Inc. (with its affiliates, "Company")
                that link to these Terms of Service and include the website,
                career services platform, and coaching services (collectively
                with Exec, the "Services").
              </p>

              <p>
                By accessing, downloading and/or using all or any part of the
                Services, you ("You" and, where applicable, "Your") indicate
                Your acceptance of the following terms from Exec Holdings, Inc.
                ("Company"). You agree to be bound by all the terms and
                conditions of this Agreement. You agree that it is enforceable
                as if it were a written negotiated agreement signed by You. If
                You do not agree to the terms of this Agreement, You may not
                access, download and/or use the Services. If You are entering
                into this Agreement on behalf of a company or other legal
                entity, You hereby represent that You have the authority to bind
                such entity to this Agreement, in which case the term "You"
                shall be construed to refer to such entity.
              </p>

              <h3>Use of the Services</h3>
              <p>
                The Services are made available to individuals and entities
                seeking the Services, directly or indirectly, including but not
                limited to companies, agencies or other parties. You acknowledge
                and agree that your license to access the Services are
                automatically revoked upon your attempt to use the Services for
                any other purpose.
              </p>

              <h3>Website Rules</h3>
              <h4>Access Rules</h4>
              <p>
                Use of any automated system or software to extract data from
                {DOMAIN} (such as scraping or crawling) is strictly prohibited.
                Company reserves the right to take such action as it deems
                necessary, including issuing legal proceedings without further
                notice.
              </p>
              <p>
                Company may access and use certain content available on
                third-party websites to enhance and provide the Services.
              </p>

              <p>
                You agree to only access or attempt to access the Services
                through its intended interface. You agree that you will not
                engage in any activity that interferes with or disrupts the
                Services, its servers or networks. Unless you have been
                specifically permitted to do so in a separate, written agreement
                with Company, you agree that you will not crawl, scrape,
                reproduce, duplicate, copy, sell, trade or resell the Services
                for any purpose. You agree that you are solely responsible for
                any breach of your obligations under these Terms of Service, and
                for any consequences (including any loss or damage which Company
                may suffer) of any such breach.
              </p>
              <h4>Appropriate Material</h4>
              <p>
                You agree that you shall not transmit or upload to or through
                the Services any harmful code, or use or misappropriate the
                Services for your own commercial gain. This includes any
                software that is designed to damage, disrupt, disable, harm,
                impair, interfere with, intercept, expropriate or otherwise
                impede in any manner, any data, storage media, program, system,
                equipment or communication.
              </p>

              <p>
                You agree that you will not transmit, send, or upload any
                material through the Services that is unlawful, false,
                defamatory, harassing, abusive, fraudulent, infringing, obscene,
                or otherwise objectionable. This may include, but it not limited
                to, transmission of content that may be harmful to minors,
                disclosure of confidential information you do not have the
                consent to disclose, attempt to impersonate another person or
                entity, or otherwise misrepresent your identity, provide false
                information, promote or encourage illegal activity, interfere
                with another user's enjoyment of the Services, violate the legal
                rights of others, or create multiple accounts without
                permission.
              </p>

              <p>
                To register for an account to use Services, you must complete a
                user profile, which you consent to be shown to other users and,
                unless you change your privacy settings, to be shown to the
                public on any portion of the Company's website. You agree to
                provide accurate and complete information on your profile – and
                on all registration and other forms you access while using our
                services or provide to us – and you agree to keep that
                information current. You agree that you will comply with all
                applicable laws, including but not limited to, privacy,
                intellectual property, anti-spam, export control, tax, and
                regulatory obligations.
              </p>

              <h4>Prohibited Uses and Competition</h4>
              <p>
                You agree not to use the Services, directly or indirectly, for
                any of the following purposes:
              </p>
              <ol>
                <li>
                  To develop, launch, or assist in the development or launch of
                  a product or service that competes with any aspect of the
                  Services or Company's business;
                </li>
                <li>
                  To analyze, assess, or reverse engineer the Services for the
                  purpose of developing competing products or services;
                </li>
                <li>
                  To collect, analyze, or use any information about the
                  Services' features, functionality, or user experience to
                  create or enhance competing products or services;
                </li>
                <li>
                  To assist, encourage, or enable others to do any of the above.
                </li>
              </ol>
              <p>
                Company reserves the right to determine, in its sole discretion,
                what constitutes a competing product or service. If Company
                determines that you are using the Services in violation of these
                restrictions, Company may immediately terminate your access to
                the Services and issue a prorated refund for any unused portion
                of prepaid services.
              </p>
              <p>
                The obligations in this section shall survive the termination of
                your use of the Services.
              </p>

              <h4>Communication Consent</h4>
              <p>
                You agree that Company may communicate with you (directly or
                through a third-party), through the Services, or by email,
                phone, or postal mail, and use contact information that you
                provide to Company, or that Company obtains from third-parties.
                By providing your email or mobile phone number, you expressly
                consent to receiving communication via such email or mobile
                number. To revoke consent at any time, you may contact us hello@
                {DOMAIN}.
              </p>

              <h4>Age Requirements</h4>
              <p>
                The Services are not for use by anyone under the age of 16.
                However, if local laws provide for an alternative minimum age
                for Company to lawfully provide the Services to you, then that
                shall apply as the applicable minimum age. If you are under the
                age of 18, or the age of majority in your jurisdiction, you must
                use the Services under the supervision of your parent, legal
                guardian, or responsible adult.
              </p>

              <h4>Data Sharing</h4>
              <p>
                If you use the Services, you agree and consent to Company
                sharing your information with coaches and other third parties
                for the purpose of delivering services necessary for Company to
                provide the Services. You also agree and consent to those
                third-parties using and sharing that necessary information
                internally and with others in order to assist Company to provide
                the Services.
              </p>

              <h4>Feedback</h4>
              <p>
                You can submit questions, comments, feedback, suggestions,
                ideas, plans, notes, drawings, original or creative materials or
                other information, regarding our Services or Company
                (collectively, "Feedback"). Feedback is non-confidential and
                will become the sole property of Company. Company will own, and
                you hereby assign to Company, all right, title, and interest,
                including all intellectual property rights, in and to such
                Feedback, and Company will be entitled to the unrestricted use
                and dissemination of Feedback for any purpose, commercial or
                otherwise, without acknowledgment or compensation to you. You
                agree to execute any documentation required by Company to
                confirm such assignment to Company.
              </p>

              <h3>Payment</h3>
              <p>
                If you use the Services, you agree to pay Company under the
                terms outlined within the applicable Order Form or the checkout
                page. You also agree that Company will store payment information
                (including, but not limited to, bank account, credit card,
                billing address, and/or other information). Any payments made
                via a credit card that are in excess of $10,000 USD will be
                subject to a 2.9% processing fee.
              </p>

              <h3>Credit Expiration</h3>
              <p>
                Unless otherwise specified in an affiliated Order Form, credits
                purchased through from Company may be redeemed for up to 12
                months after the date of original purchase. After 12 months, the
                credits will expire and will be removed from your account. If
                you use the Services, you agree that any expired credits are
                permanently forfeited and are not eligible for a refund.
              </p>

              <h3>Refunds</h3>
              <p>
                A credit purchase is eligible for a 75% refund of the original
                purchase price within 60 days of purchase if none of the credits
                have been used. Orders are not eligible for partial refunds. For
                credits purchased as a gift, only the original purchaser can
                initiate a refund and only if the recipient has not claimed the
                credits.
              </p>

              <h3>Confidentiality</h3>
              <p>
                During the course of delivering Services, Confidential
                Information might be disclosed by You or Company. "Confidential
                Information" means any non-public information that is either
                marked as confidential or which any reasonable person would
                understand to be confidential. The party receiving the
                Confidential Information may only use it for purposes related to
                these Terms or delivering the Services. The Confidential
                Information may not be disclosed to a third party, unless that
                third party is involved in the delivery of the Services or
                obligated under these Terms. The Confidential Information will
                remain confidential unless it becomes widely known or made
                generally available through no fault of the receiving party.
              </p>

              <h3>Disclaimer of Warranties</h3>
              <p>
                TO THE EXTENT ALLOWED UNDER LAW, "COMPANY" AND ITS AFFILIATES
                (A) DISCLAIMS ALL IMPLIED WARRANTIES AND REPRESENTATIONS (E.G.
                WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
                ACCURACY OF DATA, AND NONINFRINGEMENT); (B) DOES NOT GUARANTEE
                THAT THE "SERVICES" WILL FUNCTION WITHOUT INTERRUPTION OR
                ERRORS, AND (C) PROVIDES THE "SERVICES" ON AN "AS IS" AND "AS
                AVAILABLE" BASIS.
              </p>

              <h3>Limitation of Liability</h3>
              <p>
                TO THE EXTENT PERMITTED UNDER LAW (AND UNLESS "COMPANY" HAS
                ENTERED INTO A SEPARATE WRITTEN AGREEMENT THAT OVERRIDES THESE
                TERMS OF SERVICE), "COMPANY" AND ITS AFFILIATES (AND THOSE THAT
                "COMPANY" WORK WITH TO PROVIDE THE "COMPANY" SERVICES) SHALL NOT
                BE LIABLE TO YOU OR OTHERS FOR ANY INDIRECT, INCIDENTAL,
                SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR ANY LOSS OF DATA,
                OPPORTUNITIES, REPUTATION, PROFITS OR REVENUES, RELATED TO THE
                SERVICES (E.G. OFFENSIVE OR DEFAMATORY STATEMENTS, DOWN TIME OR
                LOSS, USE OF, OR CHANGES TO, YOUR INFORMATION OR CONTENT).
              </p>

              <p>
                IN NO EVENT SHALL THE LIABILITY OF "COMPANY" AND ITS AFFILIATES
                (AND THOSE THAT "COMPANY" WORK WITH TO PROVIDE THE "SERVICES")
                EXCEED, IN THE AGGREGATE FOR ALL CLAIMS, AN AMOUNT THAT IS THE
                GREATER THAN THE FEES YOU HAVE INCURRED IN USING THE "SERVICES".
              </p>

              <p>
                THIS LIMITATION OF LIABILITY IS PART OF THE BASIS OF THE BARGAIN
                BETWEEN YOU AND "COMPANY" AND SHALL APPLY TO ALL CLAIMS OF
                LIABILITY (E.G. WARRANTY, TORT, NEGLIGENCE, CONTRACT, LAW) AND
                EVEN IF EXEC.COM OR ITS AFFILIATES HAVE BEEN TOLD OF THE
                POSSIBILITY OF ANY SUCH DAMAGE, AND EVEN IF THESE REMEDIES FAIL
                THEIR ESSENTIAL PURPOSE.
              </p>
              <h3>Intellectual Property</h3>
              <p>
                Company reserves all of its intellectual property in the
                Services. Using the Services does not give you any license or
                ownership in the Services. Exec.com and related logos are the
                trademarks of Company.
              </p>
              <p>
                If you believe in good faith that your copyright has been
                violated, you may send us a notice of infringement pursuant to
                the Digital Millennium Copyright Act (17 U.S.C. § 512) at the
                following address:
              </p>
              <p>440 N. Barranca #1890 Covina, CA 91723</p>

              <h3>Governing Law and Dispute Resolution</h3>
              <p>
                You agree that the laws of the State of California, excluding
                its conflict of laws rules, shall exclusively govern any dispute
                to these Terms of Service or the Services. You agree that all
                claims and disputes can be litigated only in the federal or
                state courts in San Francisco County, California, and that you
                agree to personal jurisdiction in those courts.
              </p>
              <h3>Termination</h3>
              <p>
                Unless otherwise stipulated in an applicable Order Form, Company
                reserves the right at all times to terminate users and provision
                of the Services for any reason, without notice. On termination,
                you will lose the right to access or use the Services. These
                Terms of Service will survive termination.
              </p>

              <h3>Miscellaneous</h3>
              <p>
                If a court with authority over the Services or these Terms of
                Service find any part of the Terms of Service or Privacy Policy
                unenforceable, you agree that the court should modify the terms
                to make it enforceable while still achieving its intent. If a
                court finds modification not possible, you agree to ask the
                court to remove the unenforceable part, and that the rest of the
                terms are enforceable.
              </p>

              <p>
                These Terms of Service are not assignable or transferable
                without the prior written consent by Exec.com. If we do not
                enforce a breach of these Terms of Service, you agree that
                Company has not waived its rights.
              </p>
              <h3>Changes and Updates to These Terms of Service</h3>
              <p>
                Company reserves the right to change, modify, add or delete
                portions of these Terms of Service at any time. Your use of the
                Services constitutes your binding acceptance of such changes.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <PublicFooter />
    </>
  );
}
